import { mutatorAction } from 'satcheljs';
import getStore from '../store/store';

export default mutatorAction(
    'SET_OPTIONS_SEARCH_QUERY',
    (query: string, suppressFailedSearchDatapoints: boolean) => {
        getStore().query = query;
        getStore().suppressFailedSearchDatapoints = suppressFailedSearchDatapoints;
    }
);
